import request from '@/utils/request'

export interface EntitlementProduct {
  id: number
  name: string
  platform: string
  productId: string
  basePlanId?: string | null
  offerId?: string | null
  description?: string
  sourceType: string
  featureGrants: any[]
  metadata: any
  isActive: boolean
  // Display fields for mobile app
  buttonText?: string | null
  code?: string | null
  title?: string | null
  displayOrder?: number | null
  packageType?: 'monthly' | 'yearly' | 'monthly-consult' | 'additional-consult' | null
  isFirstSubscription: boolean
  isTest: boolean
  testUsers?: string | null
  priceAmount?: number | null
  priceCurrency?: string | null
  showInApp: boolean
  region?: string | null
  createdAt: Date
  updatedAt: Date
}

export const listEntitlementProducts = (params: any) =>
  request({
    url: '/entitlement-products',
    method: 'get',
    params
  })

export const getEntitlementProductById = (id: number) =>
  request({
    url: `/entitlement-products/${id}`,
    method: 'get'
  })

export const createEntitlementProduct = (data: any) =>
  request({
    url: '/entitlement-products',
    method: 'post',
    data
  })

export const updateEntitlementProduct = (id: number, data: any) =>
  request({
    url: `/entitlement-products/${id}`,
    method: 'put',
    data
  })

export const deleteEntitlementProduct = (id: number) =>
  request({
    url: `/entitlement-products/${id}`,
    method: 'delete'
  })

export const testProductResolution = (id: number, data: any) =>
  request({
    url: `/entitlement-products/${id}/test`,
    method: 'post',
    data
  })
